import { render, staticRenderFns } from "./housingZu.vue?vue&type=template&id=9352598a&scoped=true"
import script from "./housingZu.vue?vue&type=script&lang=js"
export * from "./housingZu.vue?vue&type=script&lang=js"
import style0 from "./housingZu.vue?vue&type=style&index=0&id=9352598a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9352598a",
  null
  
)

export default component.exports